import { render, staticRenderFns } from "./kunzila.vue?vue&type=template&id=70fdedd6&scoped=true&"
import script from "./kunzila.vue?vue&type=script&lang=js&"
export * from "./kunzila.vue?vue&type=script&lang=js&"
import style0 from "./kunzila.vue?vue&type=style&index=0&id=70fdedd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fdedd6",
  null
  
)

export default component.exports